import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewEditorComponent} from './view-editor.component';
import {ComponentsModule} from '../../components/components.module';
import {ViewItemEditorComponent} from './view-item-editor/view-item-editor.component';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {MenuModule} from 'primeng/menu';
import {SplitButtonModule} from 'primeng/splitbutton';
import {DividerModule} from 'primeng/divider';
import {InputTextModule} from 'primeng/inputtext';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PanelModule} from 'primeng/panel';
import {DatePickerModule} from 'primeng/datepicker';
import {MultiSelectModule} from 'primeng/multiselect';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {TreeModule} from 'primeng/tree';
import {OrderListModule} from 'primeng/orderlist';
import {ChipsModule} from 'primeng/chips';
import {PickListModule} from 'primeng/picklist';
import {ChipModule} from 'primeng/chip';
import {TabViewModule} from 'primeng/tabview';
import {MonacoEditorModule} from "ngx-monaco-editor-v2";
import {ToastModule} from "primeng/toast";
import { PipesModule } from '../../pipes/pipes.module';
import { FilterMenuByPermissionsPipe } from '../../pipes/filter-menu-by-permissions.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ViewEditorComponent,
        ViewItemEditorComponent
    ],
    providers:[FilterMenuByPermissionsPipe],
    imports: [
        CommonModule,
        ComponentsModule,
        RouterModule,
        ButtonModule,
        TableModule,
        MenuModule,
        SplitButtonModule,
        DividerModule,
        InputTextModule,
        DynamicDialogModule,
        FormsModule,
        PanelModule,
        DatePickerModule,
        MultiSelectModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        ReactiveFormsModule,
        DropdownModule,
        ConfirmPopupModule,
        TreeModule,
        OrderListModule,
        ChipsModule,
        PickListModule,
        ChipModule,
        TabViewModule,
        MonacoEditorModule,
        ToastModule,
        PipesModule,
        TranslateModule
    ],
    exports: [ViewEditorComponent]
})
export class ViewEditorModule {
}
